<template>
  <div>
    <div>
      <label class="p-label required" v-text="label"/>
    </div>
    <div class="p-block-inline">
      <label class="p-label">+7</label>
      <InputText :value="value"
                 :disabled="disabled"
                 v-mask="'### ### ## ##'"
                 type="text"
                 @input="inputPhone"
                 @focus="focusPhone"
      />
    </div>

    <InlineMessage v-if="validator.$dirty && !validator.required"
                   v-text="$t('validation.requiredPhone')"
                   severity="error"
                   style="width: 100%"
    />
    <InlineMessage v-if="validator.$invalid && validator.$dirty && !validator.phoneValidator"
                   v-text="$t('validation.invalid')"
                   severity="error"
                   style="width: 100%"
    />
  </div>
</template>

<script>
export default {
  name: 'InputPhone',
  props: {
    value: String,
    validator: Object,
    label: String,
    disabled: Boolean
  },
  methods: {
    inputPhone(event) {
      this.$emit('input', event)
    },
    focusPhone(event) {
      this.$emit('focus', event)
    }
  }
}
</script>
